
import { mapState } from 'vuex'
import { SlideXRightTransition } from 'vue2-transitions'

export default {
  name: 'DefaultLayout',
  components: { SlideXRightTransition },
  computed: {
    ...mapState(['displayCart'])
  },
  watch: {
    displayCart(open) {
      if (open) document.body.classList.add('noscroll')
      else document.body.classList.remove('noscroll')
    }
  },
  head() {
    return this.$nuxtI18nSeo()
  }
}
